import { create } from 'zustand';
import { api } from '@/lib/api';
import type { User } from '@shared/types';

type AuthUser = Pick<User, 'id' | 'email' | 'display_name' | 'username' | 'bio' | 'avatar_key' | 'cover_key' | 'neighborhood' | 'birthday' | 'is_verified' | 'role'>;

interface AuthState {
  user: AuthUser | null;
  loading: boolean;
  initialized: boolean;
  fetchUser: () => Promise<void>;
  logout: () => Promise<void>;
  setUser: (user: AuthUser) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  initialized: false,

  fetchUser: async () => {
    try {
      set({ loading: true });
      const user = await api.get<AuthUser>('/auth/me');
      set({ user, loading: false, initialized: true });
    } catch {
      set({ user: null, loading: false, initialized: true });
    }
  },

  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch {
      // ignore
    }
    set({ user: null });
    window.location.href = '/';
  },

  setUser: (user) => set({ user }),
}));
